import DOMPurify from 'dompurify';

const SIMPLE_TEMPLATE_HTML_TAG_PATTERN = /<\/?(?:b|strong|br)\b[^>]*>/i;
const SIMPLE_TEMPLATE_HTML_ALLOWED_TAGS = ['b', 'strong', 'br'];

export function shouldRenderSimpleTemplateHtml(fieldType: unknown, value: any): boolean {
  const normalizedFieldType = String(fieldType || '').trim().toLowerCase();
  if (normalizedFieldType !== 'textarea') {
    return false;
  }

  if (value === undefined || value === null) {
    return false;
  }

  return SIMPLE_TEMPLATE_HTML_TAG_PATTERN.test(String(value));
}

export function sanitizeSimpleTemplateHtml(value: any): string {
  const normalizedValue = String(value || '').replace(/\r\n/g, '\n');
  const withLineBreaks = normalizedValue.replace(/\n/g, '<br/>');

  return DOMPurify.sanitize(withLineBreaks, {
    ALLOWED_TAGS: SIMPLE_TEMPLATE_HTML_ALLOWED_TAGS,
    ALLOWED_ATTR: [],
  });
}
